import { ReturnLogsReadable, ReturnLogsTypeEnum } from '@crm/api'
import { Card, theme, Timeline } from 'antd'
import {
  Call,
  Chart,
  Edit,
  Message,
  Profile2User,
  Shapes1,
  Sms,
  TagUser,
  Task,
  UserEdit,
  Warning2
} from 'iconsax-react'

import {
  ActivityLogCall,
  ActivityLogChat,
  ActivityLogDefault,
  ActivityLogEmail,
  ActivityLogError,
  ActivityLogForm,
  ActivityLogLeadChange,
  ActivityLogLeadSequenceChange,
  ActivityLogMeeting,
  ActivityLogNote,
  ActivityLogOpportunity,
  ActivityLogTask
} from './ActivityLogsTypes'

interface ActivityLogItemProps {
  logs: ReturnLogsReadable[]
}

const typeIcon = {
  [ReturnLogsTypeEnum.TASK]: <Task size={14} />,
  [ReturnLogsTypeEnum.OPPORTUNITY_CHANGE]: <TagUser size={14} />,
  [ReturnLogsTypeEnum.LEAD_CHANGE]: <Profile2User size={14} />,
  [ReturnLogsTypeEnum.CHAT]: <Message size={14} />,
  [ReturnLogsTypeEnum.CALL]: <Call size={14} />,
  [ReturnLogsTypeEnum.EMAIL]: <Sms size={14} />,
  [ReturnLogsTypeEnum.MEETING]: <Shapes1 size={14} />,
  [ReturnLogsTypeEnum.NOTE]: <Edit size={14} />,
  [ReturnLogsTypeEnum.LEAD_SEQUENCE_CHANGE]: <UserEdit size={14} />,
  [ReturnLogsTypeEnum.ERROR]: <Warning2 size={14} />,
  [ReturnLogsTypeEnum.FORM]: <Chart size={14} />
}

const activityTypeComponent = {
  [ReturnLogsTypeEnum.TASK]: ActivityLogTask,
  [ReturnLogsTypeEnum.OPPORTUNITY_CHANGE]: ActivityLogOpportunity,
  [ReturnLogsTypeEnum.LEAD_CHANGE]: ActivityLogLeadChange,
  [ReturnLogsTypeEnum.CHAT]: ActivityLogChat,
  [ReturnLogsTypeEnum.CALL]: ActivityLogCall,
  [ReturnLogsTypeEnum.EMAIL]: ActivityLogEmail,
  [ReturnLogsTypeEnum.MEETING]: ActivityLogMeeting,
  [ReturnLogsTypeEnum.NOTE]: ActivityLogNote,
  [ReturnLogsTypeEnum.LEAD_SEQUENCE_CHANGE]: ActivityLogLeadSequenceChange,
  [ReturnLogsTypeEnum.ERROR]: ActivityLogError,
  [ReturnLogsTypeEnum.FORM]: ActivityLogForm
}

export const ActivityLogItem = ({ logs }: ActivityLogItemProps) => {
  const { token } = theme.useToken()

  const iconColor = {
    task: token.colorInfo,
    opportunity_change: token.colorSuccess,
    lead_change: token.colorPrimary,
    call: token.colorPrimary,
    email: token.colorPrimary,
    meeting: token.colorError,
    note: token.colorTextSecondary,
    lead_sequence_change: token.colorWarning,
    error: token.colorError,
    form: token.colorPrimary
  }

  const timelineItems = logs?.map((item) => {
    const TypeComponent =
      activityTypeComponent[item.type as keyof typeof activityTypeComponent] ||
      ActivityLogDefault

    return {
      children: (
        <Card size="small">
          <TypeComponent log={item} />
        </Card>
      ),
      dot: typeIcon?.[item?.type as keyof typeof typeIcon],
      color: iconColor?.[item?.type as keyof typeof iconColor]
    }
  })

  return <Timeline items={timelineItems} />
}
